import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row-reverse;
	width: 84%;
	margin: 0 auto;
	position: relative;
	top: 4em;

	img {
		width: 51%;
	}

	p {
		width: 14.7586em;
		color: #fff;
		text-align: center;
		paint-order: stroke fill;
		filter: drop-shadow(0 0.07em 0 #000);
		-webkit-text-stroke-width: 0.205em;
		-webkit-text-stroke-color: #000;
		font-family: "Baloo";
		font-size: 2.9em;
		font-style: normal;
		font-weight: 400;
		line-height: 1.3448em;
		margin: 0 auto;
	}

	&.portrait {
		display: block;
		width: auto;

		img {
			width: 100%;
		}

		p {
			width: 9.2413em;
		}
	}

	&.mega-menu-variant {
		top: 0;
		height: 100%;

		p {
			font-size: 1.9em;
		}

		img {
			width: 50%;
		}
	}
`;
